import { Controller } from "@hotwired/stimulus"
import { useTurboCache, cleanupBootstrapInstances, initBootstrapComponents } from "../utils/use_turbo_cache"

/**
 * Tooltip Controller
 * 
 * Initializes Bootstrap tooltips on elements within the controller scope.
 * Handles both data-bs-toggle="tooltip" and legacy data-toggle="tooltip".
 * Properly disposes tooltips on disconnect and before Turbo cache.
 * 
 * @controller tooltip
 * 
 * @example Container with tooltip triggers
 * <div data-controller="tooltip">
 *   <button data-bs-toggle="tooltip" title="Click to edit">
 *     <i class="fa fa-edit"></i>
 *   </button>
 * </div>
 * 
 * @used-in app/views/www/products/_sku_body.html.erb
 * @used-in app/views/crm/ (various CRM views)
 * @used-in app/views/www/showcases/index.html.erb
 */
export default class extends Controller {
  static selector = '[data-bs-toggle="tooltip"], [data-toggle="tooltip"]'
  static options = { html: true, sanitize: false }

  connect() {
    this.initializeTooltips()
    useTurboCache(this, { cleanup: this.cleanupTooltips.bind(this) })
  }

  initializeTooltips() {
    if (!window.bootstrap?.Tooltip) return
    initBootstrapComponents(
      this.element,
      this.constructor.selector,
      window.bootstrap.Tooltip,
      this.constructor.options
    )
  }

  cleanupTooltips() {
    if (!window.bootstrap?.Tooltip) return
    cleanupBootstrapInstances(
      this.element,
      this.constructor.selector,
      window.bootstrap.Tooltip.getInstance
    )
  }
}
